/** Вкладки диалога цепочки: значение ?tab= того же диалога. */
export type AutomationTab = "edit" | "participants";

export const AUTOMATION_TABS: readonly AutomationTab[] = [
  "edit",
  "participants",
];

/** Значение ?tab=, если это одна из вкладок диалога цепочки, иначе null. */
export const automationTabOf = (value: string | null): AutomationTab | null =>
  AUTOMATION_TABS.find((tab) => tab === value) ?? null;
